import React from "react";

const ArrowLeftIcon = ({
    className
}) => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" className={className || ''}>
            <g id="arrow_back">
                <mask id="mask0_850_5189" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
                    <rect id="Bounding box" width="16" height="16" fill="#D9D9D9" />
                </mask>
                <g mask="url(#mask0_850_5189)">
                    <path id="arrow_back_2" d="M5.21602 8.66663L8.94935 12.4L7.99935 13.3333L2.66602 7.99996L7.99935 2.66663L8.94935 3.59996L5.21602 7.33329H13.3327V8.66663H5.21602Z" fill="currentColor" />
                </g>
            </g>
        </svg>
    );
};

export default ArrowLeftIcon;
